var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:#fff;}.a{opacity:0;}.b{stroke:#fff;}.b,.c{stroke-linecap:round;stroke-linejoin:round;}.c{stroke:#666;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 12,
    height: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.29 2.499)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2,2h8a1,1,0,0,1,1,1V9a1,1,0,0,1-1,1H2A1,1,0,0,1,1,9V3A1,1,0,0,1,2,2Z",
    transform: "translate(-1.29 -2.499)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11,3,6,6.5,1,3",
    transform: "translate(-1.29 -2.499)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.74485a7d26dda77fa1e4c899d0332b52.svg";
export { ForwardRef as ReactComponent };